// UT30 is an unique code to identify each widget in the BPPR ecosystem
export const UT30NS1ROI = '30AS5';
export const data1 = [{ group: 'value', value: 45 }];
export const data2 = [{ group: 'value', value: 85 }];
export const data3 = [{ group: 'value', value: 55 }];
export const gauge1 = { numberFormatter: 1234, showPercentageSymbol: false };
export const link =
  'https://community.ibm.com/community/user/aiops/communities/community-home?communitykey=5a69b903-4d5f-4aaa-a21d-018ab33b60e2';
